import Icon from "@portal/components/atoms/icons";

export const GetIconForRiskPage = (index: number) => {
  const size = "xxlarge";
  if (index === 0) return <Icon name={"manWithChoicesYellowIcon"} size={size} />;
  if (index === 1) return <Icon name={"womanWithMobileYellowIcon"} size={size} />;
  if (index === 2) return <Icon name={"womanWithGoalsYellowIcon"} size={size} />;
  if (index === 3) return <Icon name={"manWithMobileBlueIcon"} size={size} />;
};
